import { localStorage } from "./localStorage";
import parseJSON from "./parseJSON";
import fetch from "./fetch";
import { IProfile } from "../interfaces/models";
import { CancellablePromise } from "../interfaces/api";

export type IAuthUser = {
  avatar: string,
  email: string,
  id: number,
  name: string,
  telegram_id: number,
  type_user: number
  admin_account_group_id: number
}

export type IAuthProfile = { token: string, user: IAuthUser };

export const LOCALSTORAGE_TOKEN_KEY = 'token';
export const LOCALSTORAGE_TOKENS_KEY = 'tokens';

let _setUsers: ((users: { current: IAuthProfile, others: IAuthProfile[] }) => any);
let _usersGetter = new Promise<{ current: IAuthProfile, others: IAuthProfile[] }>(res => {
  _setUsers = res;
})
export const getUsers = () => _usersGetter;

let previousToken: string;
if (window.URLSearchParams) {
  const params = new window.URLSearchParams(location.search);
  const tempToken = params.get('token');
  if (tempToken) {
    previousToken = localStorage.get(LOCALSTORAGE_TOKEN_KEY);
    localStorage.set(LOCALSTORAGE_TOKEN_KEY, tempToken);
  }
}

export const getToken = () => localStorage.get(LOCALSTORAGE_TOKEN_KEY);

export const getTokens = (): string[] => {
  const currentToken = getToken();
  let tokens = parseJSON(localStorage.get(LOCALSTORAGE_TOKENS_KEY)) as string[];
  if (!Array.isArray(tokens)) tokens = [];
  if (previousToken) tokens.unshift(previousToken);
  if (currentToken) tokens.unshift(currentToken);
  return filrateTokens(tokens);
};

const filrateTokens = (tokens: string[]) => {
  const tokensMap: Record<string, boolean> = {};
  return tokens.filter((token) => {
    if (typeof token !== 'string' || tokensMap[token]) return false;
    tokensMap[token] = true;
    return true;
  });
}

const processUsers = (current: IAuthProfile, others: IAuthProfile[]) => {
  const result = { current, others };
  _setUsers(result);
  return result;
}

export const loadUsers = (): CancellablePromise<{ current: IAuthProfile, others: IAuthProfile[] }> => {
  const currentToken = getToken();
  const tokens = getTokens();
  if (!tokens.length) return Promise.resolve(processUsers(null, []));
  return fetch<IAuthProfile[]>('POST', 'auth/users', { tokens })
    .catch(() => ([] as IAuthProfile[]))
    .then((users) => {
      const current = users.find(({ token }) => token === currentToken);
      const processedUsers: Record<string, boolean> = {};
      if (current) processedUsers[current.user.id] = true;

      const others = users.filter(({ token, user }) => {
        if (processedUsers[user.id]) return false;
        processedUsers[user.id] = true;
        return true
      });

      if (!current) localStorage.remove(LOCALSTORAGE_TOKEN_KEY);
      localStorage.set(LOCALSTORAGE_TOKENS_KEY, JSON.stringify(others.map(({ token }) => token)));

      return processUsers(current, others);
    });
}

export const authToken = (token: string) => {
  const currentToken = getToken();
  if (currentToken === token) return;
  const tokens = getTokens();
  tokens.unshift(currentToken)
  localStorage.set(LOCALSTORAGE_TOKEN_KEY, token);
  localStorage.set(LOCALSTORAGE_TOKENS_KEY, JSON.stringify(filrateTokens(tokens)));
}

export const unauthToken = (token: string) => {
  if (localStorage.get(LOCALSTORAGE_TOKEN_KEY) === token) localStorage.remove(LOCALSTORAGE_TOKEN_KEY);
  let tokens = getTokens();
  localStorage.set(LOCALSTORAGE_TOKENS_KEY, JSON.stringify(tokens.filter(t => t !== token)));
}

export const redirectUser = (path: string) => {
  setTimeout(() => {
    const { pathname, search } = location;
    window.location.href = `/auth${path}?change&redirect=${encodeURIComponent(pathname + search)}`;
  }, 100);
}

export const unauth = () => {
  const currentToken = getToken();
  unauthToken(currentToken);
  redirectUser('');
}

export const changeAccount = () => redirectUser('');

export const addAccount = () => redirectUser('/login');
